var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.888 25.642 12.398-6e-3m-19.934-0.2558 1.8038 1.5503 2.6945-3.2601m3.0421 10.15 7.3534-4e-3m-14.89-0.2575 1.8048 1.5503 2.6945-3.2601m12.21 8.3731h-20.163c-1.0503 0-1.9027-0.8514-1.9027-1.9027v-23.417c0-1.0503 0.8524-1.9027 1.9027-1.9027h26.968c1.0503 0 1.9027 0.8514 1.9027 1.9027v17.762m-2.2501-14.167h-25.849m24.202-2.7491h-1.4796m-3.2036 0h-1.4806m12.434 20.516-10.786-4.9882 3.2157 11.378 2.0664-2.8713 2.8955 3.4328 2.2159-1.8704-2.8956-3.4339 3.2884-1.6472z",
    stroke: "#878686",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepare);
export default __webpack_public_path__ + "static/media/prepare.ebd926565270eeb29642f448c46c3b27.svg";
export { ForwardRef as ReactComponent };